import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes, { oneOfType } from 'prop-types';
import { Grid } from '@material-ui/core';
import DateInputFieldWithValidation from '../../../../components/ValidationFormElements/DateInputFieldWithValidation';
import TextInputFieldWithValidation from '../../../../components/ValidationFormElements/TextInputFieldWithValidation';
import useUnRegisterValidationFields from '../../../../hooks/useUnRegisterValidationFields';
import useRegisterValidationFields from '../../../../hooks/useRegisterValidationFields';

import styles from '../../Steps/steps.module.scss';

const OtherCitizenForm = ({
  errors,
  clearError,
  givenDate,
  updateGivenDate,
  updateValidUntilDate,
  validUntilDate,
  register,
  unregister,
  handleChange,
  setValue,
}) => {
  const { t } = useTranslation();

  useRegisterValidationFields(
    ['passportGivenDate', 'passportValidUntilDate', 'passportFrom'],
    register,
  );

  useUnRegisterValidationFields(
    ['passportGivenDate', 'passportValidUntilDate', 'passportFrom'],
    unregister,
  );

  useEffect(() => {
    setValue('passportGivenDate', givenDate, !!givenDate);
  }, [givenDate, setValue]);

  useEffect(() => {
    setValue('passportValidUntilDate', validUntilDate, !!validUntilDate);
  }, [validUntilDate, setValue]);

  return (
    <Grid container spacing={4}>
      <Grid item md={4} xl={4} lg={4} xs={12}>
        <label htmlFor="passportGivenDate" className={styles.inputLabel}>
          {t('claim.personalData.givenDate')}
        </label>
        <DateInputFieldWithValidation
          formProps={{ errors, clearError }}
          name="passportGivenDate"
          value={givenDate ? new Date(givenDate) : null}
          handleChange={(date) => {
            // eslint-disable-next-line no-restricted-globals
            if (date instanceof Date && !isNaN(date)) {
              updateGivenDate(date);
            }
          }}
          maxDate={new Date()}
        />
      </Grid>
      <Grid item md={4} xl={4} lg={4} xs={12}>
        <label htmlFor="passportValidUntilDate" className={styles.inputLabel}>
          {t('cmtplForm.personalData.validUntilDate')}
        </label>
        <DateInputFieldWithValidation
          formProps={{ errors, clearError }}
          name="passportValidUntilDate"
          value={validUntilDate ? new Date(validUntilDate) : null}
          handleChange={(date) => {
            // eslint-disable-next-line no-restricted-globals
            if (date instanceof Date && !isNaN(date)) {
              updateValidUntilDate(date);
            }
          }}
          minDate={new Date()}
        />
      </Grid>
      <Grid item md={4} xl={4} lg={4} xs={12}>
        <label htmlFor="passportFrom" className={styles.inputLabel}>
          {t('cmtplForm.personalData.passportFrom')}
        </label>
        <TextInputFieldWithValidation
          formProps={{ errors, clearError }}
          name="passportFrom"
          autoComplete="off"
          register={register}
          handleChange={({ target }) => handleChange(target.value)}
        />
      </Grid>
    </Grid>
  );
};

OtherCitizenForm.propTypes = {
  errors: PropTypes.shape({}).isRequired,
  clearError: PropTypes.func.isRequired,
  updateGivenDate: PropTypes.func.isRequired,
  validUntilDate: oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  updateValidUntilDate: PropTypes.func.isRequired,
  givenDate: oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  unregister: PropTypes.func.isRequired,
};

OtherCitizenForm.defaultProps = {
  givenDate: null,
  validUntilDate: null,
};
export default OtherCitizenForm;
